import { FC } from "react";
import Spinner from "@components/Spinners";

interface Props {
    className?: string;
}

/**
 * Make sure this widget has no dependencies except FC and spinner,
 * because it is used to prerender dynamic widgets and needs to load asap
 */
const WidgetLoading: FC<Props> = ({ className }) => {
    return (
        <div
            className={`flex flex-1 items-center justify-center rounded-widget border border-border-elevated bg-background-elevated py-10 ${className}`}
        >
            <Spinner />
        </div>
    );
};

export default WidgetLoading;
